import React from "react";
import { Link } from "react-router-dom";
import "./CallToAction.css";

const CallToAction = ({
  title = "Ready to Accelerate Your Digital Growth?",
  descriptionOne = "Connect with our expert team to build secure, scalable, and stunning web solutions that drive real business results.",
  descriptionTwo = "",
  buttonText = "Get In Touch",
  buttonLink = "/contact-us",
}) => {
  return (
    <section className="cta-section">
      <div className="background-shapes" aria-hidden="true">
        <div className="code-shape">&lt;/&gt;</div>
        <div className="glow-orb glow-orb-primary"></div>
        <div className="glow-orb glow-orb-secondary"></div>
        <div className="code-card-shape">
          <p>{"const launch = {"}</p>
          <p>{"  speed: 'high',"}</p>
          <p>{"  quality: 'premium'"}</p>
          <p>{"};"}</p>
        </div>
        <div className="terminal-shape">
          <span className="terminal-label">deploy status</span>
          <strong>Build. Launch. Scale.</strong>
          <span className="terminal-command">$ npm run ship</span>
        </div>
      </div>

      <div className="container mq-cta-content">
        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div className="cta-shell">
              <h2 className="cta-heading">{title}</h2>

              <p className="cta-description">{descriptionOne}</p>

              {descriptionTwo ? (
                <p className="cta-description cta-description-secondary">
                  {descriptionTwo}
                </p>
              ) : null}

              <Link to={buttonLink} className="cta-btn">
                <span>{buttonText}</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
